import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
const {
  media_md
} = variables;


export const HeroHeader = styled.div`
  background-color: #fff;
  padding: 0px 0px 10px;
  // min-height: 200px;
  @media ${media_md} {
    padding: 0px 0px 0px;
    // min-height: 370px;
  }

`

